import classNames from 'classnames'
import { ColorDotToken } from '../../../ColorToken'
import { MenuOption } from '../../../MenuOption'
import { singleSelectClasses } from '../componentClassNames'
import { useSingleSelectSearch, useSingleSelectState } from '../contexts'
import * as styles from './styles'

type MenuItemsProps = {
  className?: string
  hideTrailingNodeUnlessSelected?: boolean
}

export const MenuItems: React.FC<React.PropsWithChildren<MenuItemsProps>> = ({
  children,
  className,
  hideTrailingNodeUnlessSelected = false,
}) => {
  const { searchTerm } = useSingleSelectSearch()
  const {
    filteredOptions,
    getItemProps,
    getMenuProps,
    hasFooter,
    hideFooterOnSearch,
    highlightedIndex,
    isOpen,
    selectedItem,
  } = useSingleSelectState()

  return (
    <ul
      css={styles.menuContent}
      {...getMenuProps({
        className: classNames(singleSelectClasses.menuItem, className),
      })}
    >
      {isOpen &&
        filteredOptions.map((option, index) => {
          const selected =
            selectedItem === option || selectedItem?.value === option.value
          return (
            <MenuOption.Root
              id={option.value}
              key={String(option.value)}
              disabled={option.disabled}
              optionText={option.label}
              selected={selected}
            >
              <MenuOption.Body
                highlightedByKeyboard={highlightedIndex === index}
                {...getItemProps({
                  index,
                  item: option,
                })}
              >
                {option.color ? <ColorDotToken color={option.color} /> : null}
                {option.leadingNode}
                <MenuOption.OptionText />
                {!option.trailingNode ||
                (hideTrailingNodeUnlessSelected && !selected) ? null : (
                  <span css={styles.trailingNode({ selected })}>
                    {option.trailingNode}
                  </span>
                )}
              </MenuOption.Body>
            </MenuOption.Root>
          )
        })}
      {children}
      {isOpen &&
        !filteredOptions.length &&
        (!hasFooter || (searchTerm && hideFooterOnSearch)) && (
          <li key="no-options" css={styles.noOptions}>
            No options available
          </li>
        )}
    </ul>
  )
}
MenuItems.displayName = 'Lapidary: MenuItems ← SingleSelect'
